import React, { useState } from "react";
import { StyleSheet, ScrollView, View } from "react-native";
import { router, useLocalSearchParams } from "expo-router";
import { ThemedText } from "@/components/ThemedText";
import { Button } from "@/components/ui/Button";
import Input from "@/components/ui/Input";
import { useTheme } from "@/hooks/useTheme";

export default function InfoScreen() {
  const { colors } = useTheme();
  const { session } = useLocalSearchParams();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const handleContinue = () => {
    // TODO: Save info and move to next step
    router.push(`/sign-up/${session}/documents`);
  };

  return (
    <ScrollView style={[styles.container, { backgroundColor: colors.background }]}>
      <View style={styles.content}>
        <ThemedText style={[styles.title, { color: colors.text }]}>Personal Information</ThemedText>
        <ThemedText style={[styles.subtitle, { color: colors.textSecondary }]}>
          Let&apos;s start with some basic information about you
        </ThemedText>

        <View style={styles.form}>
          <Input
            icon="person"
            placeholder="First Name"
            value={firstName}
            onChangeText={setFirstName}
            containerStyle={styles.input}
          />

          <Input
            icon="person"
            placeholder="Last Name"
            value={lastName}
            onChangeText={setLastName}
            containerStyle={styles.input}
          />

          <Input
            icon="email"
            placeholder="Email Address"
            value={email}
            onChangeText={setEmail}
            keyboardType="email-address"
            autoCapitalize="none"
            containerStyle={styles.input}
          />

          <Input
            icon="phone"
            placeholder="Phone Number"
            value={phone}
            onChangeText={setPhone}
            keyboardType="phone-pad"
            containerStyle={styles.input}
          />

          <Button
            text="Continue"
            iconPosition="right"
            onPress={handleContinue}
            icon="arrow-right"
            iconSize={18}
            iconColor="white"
            style={[styles.button, { backgroundColor: colors.primary }]}
            textStyle={{ color: "white", fontSize: 16 }}
            enabled={!!(firstName && lastName && email && phone)}
          />
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    padding: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 16,
    marginBottom: 32,
  },
  form: {
    gap: 16,
  },
  input: {
    minWidth: "100%",
  },
  button: {
    marginTop: 16,
    borderRadius: 8,
    minHeight: 48,
  },
});
